import type {
  GqlSelectionListKey,
  SelectionList,
} from '../../../../shared/selection-lists/types';

export const sortCitySelectionList = <T extends GqlSelectionListKey>(
  list: SelectionList<T>
) => {
  return [...list].sort((a, b) => {
    const countA = 'count' in a && typeof a.count === 'number' ? a.count : -1;
    const countB = 'count' in b && typeof b.count === 'number' ? b.count : -1;
    return countB - countA;
  });
};
